import NzRollReturnsSerializer from './base';

export default class ValidationResult extends NzRollReturnsSerializer {}
